// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { AUTH_FLOW } from './../../../types/next/blocks/authBlock'
import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'

export const authBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.AUTH),
  settings: blockBaseSettingsSchema
})

export const authFlowSchema = z.nativeEnum(AUTH_FLOW)

const iAuthControlExportsSchema = z.object({
  flow: authFlowSchema.optional(),
  email: z.string().optional(),
  oneTimePassword: z.string().optional()
})

export const authControlSkippedSchema = iAuthControlExportsSchema.extend({
  flow: z.literal(AUTH_FLOW.SKIP),
  email: z.never().optional(),
  oneTimePassword: z.never().optional()
})

export const authControlSignInFilledSchema = iAuthControlExportsSchema.extend({
  flow: z.literal(AUTH_FLOW.SIGN_IN),
  email: z.string().optional(),
  oneTimePassword: z.string().optional()
})

export const authControlSignUpFilledSchema = iAuthControlExportsSchema.extend({
  flow: z.literal(AUTH_FLOW.SIGN_UP),
  email: z.string(),
  oneTimePassword: z.never().optional()
})

export const authControlFilledSchema = z.union([
  authControlSignInFilledSchema,
  authControlSignUpFilledSchema
])

export const authBlockValueSchema = z.union([
  authControlSkippedSchema,
  authControlFilledSchema
])
